// German for WhyNow. English text is the key; a missing entry falls back to English.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Why now': 'Warum jetzt',
  'one action, chosen by the highest-scoring reason': 'eine Handlung, gewählt nach dem am höchsten bewerteten Grund',
  'score': 'Bewertung',
  'Score': 'Bewertung',
  'Reading the score…': 'Bewertung wird gelesen …',
  'The next best action could not be read: {error}': 'Die nächstbeste Handlung konnte nicht gelesen werden: {error}',
  'Nothing has scored this person yet. The rules run at 05:00, and on every interaction, signal and commitment; until one of those happens there is no score and no reason to show.':
    'Diese Person wurde noch nicht bewertet. Die Regeln laufen um 05:00 Uhr sowie bei jedem Kontakt, Signal und jeder Zusage; bis dahin gibt es keine Bewertung und keinen Grund zu zeigen.',
  'Nothing is asking for a move: no open commitment with us, no signal in thirty days, and the cadence is being kept.':
    'Nichts verlangt einen Schritt: keine offene Zusage bei uns, kein Signal seit dreissig Tagen, und die Taktung wird eingehalten.',

  // the verbs
  'send': 'schreiben', 'call': 'anrufen', 'meet': 'treffen',
  'research': 'recherchieren', 'introduce': 'vorstellen lassen', 'wait': 'abwarten',

  'written by the why_now skill; nobody has held it': 'von der Fähigkeit why_now geschrieben; niemand hat es übernommen',
  'written by {by} · the rule text stays underneath': 'geschrieben von {by} · der Regeltext bleibt darunter',
  'composed by the rules from the score breakdown': 'von den Regeln aus der Bewertungsaufschlüsselung gebildet',
  'Runners-up': 'Weitere Gründe',

  'Done': 'Erledigt',
  'Dismiss': 'Verwerfen',
  'Why this score': 'Warum diese Bewertung',
  'Hide the breakdown': 'Aufschlüsselung ausblenden',
  'Marked done. It will not be proposed again until the data asks for it.':
    'Als erledigt vermerkt. Es wird erst wieder vorgeschlagen, wenn die Daten es verlangen.',
  'Dismissed. It will not be proposed again for seven days.':
    'Verworfen. Es wird sieben Tage lang nicht erneut vorgeschlagen.',
  'No rule fired. The score is zero because nothing matched, not because nothing was looked at.':
    'Keine Regel hat ausgelöst. Die Bewertung ist null, weil nichts zutraf — nicht, weil nichts geprüft wurde.',
}, 'WhyNow');
